import { mapActions } from "vuex";

/*
 Purpose of this mixin is :
*/

export const articles = {
  data: () => ({
    groupedArticles: [],
    articlesList: []
  }),
  computed: {
    articles() {
      return this.articlesList.map(article => {
        return {
          article_id: article.article_id,
          idc_want: false,
          value: null
        };
      });
    }
  },
  methods: {
    ...mapActions({
      getLocalArticlesByModel: "articles/getLocalArticlesByModel"
    }),

    // Group array of objects by property value
    groupBy(property, array) {
      return array.reduce((objectsByKeyValue, obj, index) => {
        const value = obj[property];
        obj.index = index;
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
    },

    // Load articles
    async loadArticles(product_model, section = false) {
      try {
        const articles = await this.getLocalArticlesByModel(product_model);
        this.articlesList = articles.sort((a, b) => a.order - b.order);

        // Set section
        if (section) {
          this.groupedArticles = this.groupBy("section", this.articlesList);
        }
        return;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
